import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import './ConfirmationModal.css';

class ConfirmationModal extends PureComponent {
  constructor(props) {
    super(props);

    this.handleConfirm = this.handleSelection.bind(this, true);
    this.handleCancel = this.handleSelection.bind(this, false);
    this.handleClose = this.handleSelection.bind(this, undefined);
  }

  handleSelection(choice, ev) {
    this.props.onSelection(choice, ev);
  }

  render() {
    const {
      title,
      onSelection,
      closeButton,
      rootClose,
      showBackdrop,
      confirmText,
      cancelText,
      show,
      className,
      children,
      ...otherProps
    } = this.props;

    return (
      show && (
        <Modal
          dialogClassName={className}
          onHide={this.handleClose}
          show={show}
          backdrop={rootClose ? true : showBackdrop ? 'static' : false}
          {...otherProps}
        >
          {title && (
            <Modal.Header closeButton={closeButton}>{title}</Modal.Header>
          )}
          <Modal.Body>{children}</Modal.Body>
          <Modal.Footer>
            {cancelText && (
              <button
                onClick={this.handleCancel}
                type="button"
                className="btn btn-primary"
              >
                {cancelText}
              </button>
            )}
            {confirmText && (
              <button
                onClick={this.handleConfirm}
                type="button"
                className="btn btn-success"
              >
                {confirmText}
              </button>
            )}
          </Modal.Footer>
        </Modal>
      )
    );
  }
}

ConfirmationModal.propTypes = {
  onSelection: PropTypes.func.isRequired,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  rootClose: PropTypes.bool,
  showBackdrop: PropTypes.bool,
  show: PropTypes.bool,
  className: PropTypes.string
};

ConfirmationModal.defaultProps = {
  title: 'Confirm',
  closeButton: false,
  cancelText: 'Close',
  rootClose: true,
  showBackdrop: true,
  className: 'confirmation-modal'
};

export default ConfirmationModal;
